import { componentBuildInput } from './components/input/componentBuild';

const componentsBuild = () => {
  componentBuildInput();
  return;
};

export default componentsBuild;
